import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import * as firebase from "firebase/app";
import { Subject } from "rxjs/Subject";
import { debounceTime } from "rxjs/operator/debounceTime";
import { BillTypeService } from "../../shared/bill/bill-type.service";
import { LoaderService } from "../../shared/services/loader.service";
import { AccountService } from "./../../shared/account/account.service";
import { AuthService } from "./../../shared/services/auth.service";
import { Subscription } from "rxjs/Subscription";
import { BackendService } from "../../shared/services/backend.service";

@Component({
  selector: "app-manage-bill-type",
  templateUrl: "./manage-bill-type.component.html",
  styleUrls: ["./manage-bill-type.component.css"]
})
export class ManageBillTypeComponent implements OnInit, OnDestroy {
  private _success = new Subject<string>();
  successMessage: string;
  modalReference: NgbModalRef;
  selectedBillType: any;
  billTypeName;
  billType: any;
  billTypes;
  communityId: string;
  roleSubscription: Subscription;
  messageSubscription: Subscription;
  private authState: firebase.User | null;
  page = 1;
  userId: string;
  query = "";
  routeSubscription: Subscription;
  activeRouteIndex: number;
  user: any;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private billTypeService: BillTypeService,
    private authService: AuthService,
    private accountService: AccountService,
    private loaderService: LoaderService,
    private route: ActivatedRoute
  ) {
    this.billTypes = [];
    this.authState = this.authService.getAuthState();
    this.userId = BackendService.generateUserId(this.authState.email);
  }

  ngOnInit(): void {
    this.billTypeName = "";
    this.routeSubscription = this.route.params.subscribe(
      params => (this.activeRouteIndex = params.index)
    );
    this.getBillTypes();
    this.subscribeToSuccessMessage();
  }

  ngOnDestroy(): void {
    this.roleSubscription.unsubscribe();
    this.messageSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
  }

  open(editModal): void {
    this.modalReference = this.modalService.open(editModal);
  }

  editBillTypeName(billType, editModal): void {
    this.selectedBillType = billType;
    this.billTypeName = this.selectedBillType.name;
    this.open(editModal);
  }

  async update(): Promise<void> {
    this.loaderService.startLoader();
    const isBillTypeUnique = await new Promise<any>(resolve => {
      this.billTypeService
        .isBillTypeUnique(this.billTypeName)
        .then(result => resolve(result));
    });
    if (isBillTypeUnique) {
      this.billTypeService.update(this.selectedBillType.id, this.billTypeName);
      this.close();
      this._success.next("Bill type updated successfully.");
    }
    this.loaderService.stopLoader();
  }

  close(): void {
    this.modalReference.close();
  }

  private getBillTypes(): void {
    this.loaderService.startLoader();
    this.roleSubscription = this.accountService
      .getProfile(this.userId)
      .subscribe((profile: any) => {
        this.user = profile;
        this.route.params.subscribe(params => {
          const activeRole: any = profile.roles[params.index];
          this.communityId = activeRole.communityId;
          this.billTypeService
            .getBillTypeByRole(activeRole)
            .subscribe(result => {
             this.billTypes = activeRole.role === "Community Manager" ?
                 this.sort(result.filter(item => item.status === "enabled")) : this.sort(result);
            });
          this.loaderService.stopLoader();
        });
      });
  }

  sort(items: Array<any>): Array<any> {
    items.sort((a, b) => {
      const nameA = a.name.toUpperCase(); // ignore upper and lowercase
      const nameB = b.name.toUpperCase(); // ignore upper and lowercase
      const result = nameA < nameB ? -1 : nameA > nameB ? 1 : 0;

      return result;
    });

    return items;
  }

  private subscribeToSuccessMessage(): void {
    this.messageSubscription = this._success.subscribe(
      message => (this.successMessage = message)
    );
    debounceTime
      .call(this._success, 3000)
      .subscribe(() => (this.successMessage = undefined));
  }
}



// WEBPACK FOOTER //
// ./src/app/bill/manage-bill-type/manage-bill-type.component.ts